import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetLoanRequestsWithUnverifiedDocuments } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

export const useNewDocuments = () => {
    const queryKey = queryKeys.getLoanRequestsWithUnverifiedDocuments();
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getLoanRequestsWithUnverifiedDocuments,
        schema: schemaLoanRequestResolver_GetLoanRequestsWithUnverifiedDocuments,
        searchParams: { position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
